"use strict";

exports.__esModule = true;
var _DeviceCollection = require("./DeviceCollection");
Object.keys(_DeviceCollection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceCollection[key]) return;
  exports[key] = _DeviceCollection[key];
});
var _DeviceCollectionContext = require("./DeviceCollectionContext");
Object.keys(_DeviceCollectionContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceCollectionContext[key]) return;
  exports[key] = _DeviceCollectionContext[key];
});